<h1 matDialogTitle>
  {{ data.tfgRequestId ? "Refresh" : "Validate" }} TFG Account
</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div
      fxLayout="row wrap"
      fxLayoutAlign="start start"
      fxFlexFill
      fxLayoutGap="16px grid"
    >
      <mat-form-field fxFlex="70" width="100%">
        <mat-label>TFG Card Number</mat-label>
        <input
          matInput
          style="text-align: left"
          type="text"
          min="19"
          max="19"
          formControlName="tfgCardNumber"
          autocomplete="new-password"
          (keyup.enter)="checkForTfgCardScan($event, $event.target.value)"
        />
      </mat-form-field>

      <div fxFlex="15" width="100%">
        <button
          mat-raised-button
          color="primary"
          [disabled]="!form.valid"
          (click)="validate()"
        >
          {{ data.tfgRequestId ? "Refresh" : "Validate" }}
        </button>
      </div>
    </div>
  </form>

  <mat-tab-group *ngIf="tfgAccountDetails" style="font-size: 9pt;">
    <mat-tab label="TFG Credit">
      <div style="margin-top: 16px">
        <mat-card-subtitle>Account Details</mat-card-subtitle>
        <div
          style="width: 100%"
          fxLayout="row"
          fxLayoutAlign="start start"
          fxLayoutGap="16px"
        >
          <div fxFlex="50%">
            <table style="width: 100%">
              <tr>
                <th class="th-label" style="min-width: 90px">Acc. Status</th>
                <td class="td-value">{{ tfgAccountDetails.accountStatus }}</td>
              </tr>
              <tr>
                <th class="th-label">Acc. Type</th>
                <td class="td-value">{{ tfgAccountDetails.accountType }}</td>
              </tr>
              <tr>
                <th class="th-label">Title</th>
                <td class="td-value">{{ tfgAccountDetails.title }}</td>
              </tr>
              <tr>
                <th class="th-label">Initials</th>
                <td class="td-value">{{ tfgAccountDetails.initials }}</td>
              </tr>
              <tr>
                <th class="th-label">Surname</th>
                <td class="td-value">{{ tfgAccountDetails.surname }}</td>
              </tr>
              <tr>
                <th class="th-label">Is Primary</th>
                <td class="td-value">{{ tfgAccountDetails.isPrimary }}</td>
              </tr>
            </table>
          </div>
          <div fxFlex="50%">
            <table style="width: 100%">
              <tr>
                <th class="th-label">OTB</th>
                <td class="td-value" style="text-align: right">
                  {{ tfgAccountDetails.openToBuyAmount | number : "1.2-2" }}
                </td>
              </tr>
              <tr>
                <th class="th-label">Acc. Balance</th>
                <td class="td-value" style="text-align: right">
                  {{
                    tfgAccountDetails.accountBalanceAmount | number : "1.2-2"
                  }}
                </td>
              </tr>
              <tr>
                <th class="th-label">Instalment</th>
                <td class="td-value" style="text-align: right">
                  {{
                    tfgAccountDetails.accountInstalmentAmount
                      | number : "1.2-2" : ""
                  }}
                </td>
              </tr>
              <tr>
                <th class="th-label">Arrears</th>
                <td class="td-value" style="text-align: right">
                  {{
                    tfgAccountDetails.totalArrearsAmount | number : "1.2-2" : ""
                  }}
                </td>
              </tr>
              <tr>
                <th class="th-label">Total Due</th>
                <td class="td-value" style="text-align: right">
                  {{ tfgAccountDetails.totalDueAmount | number : "1.2-2" : "" }}
                </td>
              </tr>
              <tr>
                <th class="th-label">Credit Limit</th>
                <td class="td-value" style="text-align: right">
                  {{
                    tfgAccountDetails.totalCreditlimit | number : "1.2-2" : ""
                  }}
                </td>
              </tr>
              <tr>
                <th class="th-label">Discount %</th>
                <td class="td-value" style="text-align: right">
                  {{
                    tfgAccountDetails.maximumDiscountPercentage
                      | number : "1.2-2" : ""
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <mat-card-subtitle>Credit Plans</mat-card-subtitle>
        <mat-list dense>
          <mat-list-item *ngFor="let plan of tfgAccountDetails.creditPlans">
            {{ plan.creditPlan }}
          </mat-list-item>
        </mat-list>
      </div>
    </mat-tab>
    <mat-tab *ngIf="tfgRewardsDetails" label="Loyalty / Rewards">
      <div
        style="
          display: flex;
          flex-direction: row;
          align-content: stretch;
          justify-content: space-between;
          flex-wrap: nowrap;
          gap: 16px;
          margin-top: 16px;
        "
      >
        <div style="width: 100%">
          <mat-card-subtitle>Loyalty</mat-card-subtitle>
          <table
            style="width: 100%"
            *ngIf="
              tfgRewardsDetails?.Customer?.Loyalty &&
              tfgRewardsDetails?.Customer?.Loyalty.length > 0
            "
          >
            <tr>
              <th class="th-label" style="min-width: 90px">Account Status</th>
              <td class="td-value">
                {{ tfgRewardsDetails?.Customer?.Loyalty[0].AccountStatus }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">Savings</th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Loyalty[0].SavingsToDate
                    | number : "1.2-2"
                }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">Card Name</th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Loyalty[0].Card &&
                  tfgRewardsDetails?.Customer?.Loyalty[0].Card.length > 0
                    ? tfgRewardsDetails?.Customer?.Loyalty[0].Card[0].Name
                    : ""
                }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">Card Number</th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Loyalty[0].Card &&
                  tfgRewardsDetails?.Customer?.Loyalty[0].Card.length > 0
                    ? tfgRewardsDetails?.Customer?.Loyalty[0].Card[0].Code
                    : ""
                }}
              </td>
            </tr>
          </table>
        </div>
        <div style="width: 100%">
          <mat-card-subtitle>Options</mat-card-subtitle>
          <table
            style="width: 100%"
            *ngIf="tfgRewardsDetails?.Customer?.Option"
          >
            <tr>
              <th class="th-label" style="min-width: 90px">
                3rd Party Marketing Allowed
              </th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Option
                    ?.IsThirdPartyMarketingAllowed
                    ? "Yes"
                    : "No"
                }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">
                Marketing Allowed
              </th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Option?.IsMarketingAllowed
                    ? "Yes"
                    : "No"
                }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">Customer Blocked</th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Option?.IsCustomerBlocked
                    ? "Yes"
                    : "No"
                }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">
                Registered for Loyalty
              </th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Option?.IsRegisteredForLoyalty
                    ? "Yes"
                    : "No"
                }}
              </td>
            </tr>
            <tr>
              <th class="th-label" style="min-width: 90px">
                School Days Allowed
              </th>
              <td class="td-value">
                {{
                  tfgRewardsDetails?.Customer?.Option?.IsSchoolDaysAllowed
                    ? "Yes"
                    : "No"
                }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div style="width: 100%; margin-top: 16px">
        <kendo-grid
          [kendoGridBinding]="tfgRewardsDetails?.Promotions"
          [scrollable]="true"
          [resizable]="true"
          [reorderable]="true"
          [sortable]="true"
        >
          <kendo-grid-column [width]="180" field="Name" title="Name">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">
                {{ dataItem.Name }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="100" field="DateStart" title="Start Date">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">
                {{ dataItem.DateStart | date : "shortDate" }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="100" field="DateEnd" title="End Date">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">
                {{ dataItem.DateEnd | date : "shortDate" }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="80"
            field="NumberOfSets"
            title="Number of Sets"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">
                {{ dataItem.NumberOfSets }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="80"
            field="QuantityToPurchase"
            title="Qty to Purchase"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">
                {{ dataItem.QuantityToPurchase }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="80"
            field="ValueOffPurchase"
            title="Value off Purchase"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="ellipse">
                {{ dataItem.ValueOffPurchase }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="80" field="IsBirthday" title="Birthday">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.IsBirthday ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="80" field="IsMarkdown" title="Markdown">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.IsMarkdown ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            [width]="80"
            field="IsProductPromotion"
            title="Product Promo"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.IsProductPromotion ? "Yes" : "No" }}
            </ng-template>
          </kendo-grid-column>

          <!-- <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showEmailDetails">
          <div style="margin: 16px;">
            <kendo-grid [kendoGridBinding]="dataItem.emails" [scrollable]="true" [resizable]="true" [reorderable]="true"
              [sortable]="true">

              <kendo-grid-column [width]="150" field="emailType" title="Email. Type"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="sentAt" title="Sent At">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{dataItem.sentAt | date: 'MMM d, yyyy HH:mm'}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [width]="250" field="sentTo" title="Sent To"> </kendo-grid-column>
              <kendo-grid-column [width]="200" field="emailStatus" title="Email Status"> </kendo-grid-column>

            </kendo-grid>
          </div>
        </ng-template> -->
        </kendo-grid>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button
    *ngIf="!data.tfgRequestId"
    [disabled]="!tfgAccountDetails?.requestId"
    mat-button
    (click)="save()"
  >
    Link TFG Account
  </button>
</mat-dialog-actions>
